// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dB","header":"dC","overTitle":"dD","image":"dE","title":"dF","description":"dG","button":"dH"};